<div class="header">
  <div class="action">
    <div class="close" (click)="close()">
      <mat-icon svgIcon="cross"></mat-icon>
    </div>
  </div>
</div>

<div class="modal-header">
  <h3 class="modal-title">{{ 'auth.contract-link.title' | translate }}</h3>
</div>

<div class="modal-body">
  @if (step === 'email') {
    <p class="center">{{ 'auth.contract-link.email.message' | translate }}</p>
    <div class="input-container">
      <label class="label body-12" for="contract-link-email">
        {{ 'auth.contract-link.email.label' | translate }}
      </label>
      <input id="contract-link-email"
        type="email"
        class="input"
        inputmode="email"
        autocomplete="email"
        [placeholder]="'auth.contract-link.email.placeholder' | translate"
        [(ngModel)]="email"
        (keyup.enter)="submitEmail()"/>
      </div>
    }

    @if (step === 'code') {
      <p class="center">{{ 'auth.contract-link.code.message' | translate: { email: email } }}</p>
      <div class="input-container">
        <label class="label body-12" for="contract-link-code">
          {{ 'auth.contract-link.code.label' | translate }}
        </label>
        <input id="contract-link-code"
          type="text"
          class="input"
          inputmode="numeric"
          autocomplete="one-time-code"
          maxlength="6"
          [placeholder]="'auth.contract-link.code.placeholder' | translate"
          [(ngModel)]="code"
          (keyup.enter)="submitCode()"/>
        </div>
        @if (codeError) {
          <p class="code-error body-12">
            {{ 'auth.contract-link.code.errors.' + codeError | translate }}
          </p>
        }
        <div class="secondary-actions">
          <button class="button link text-button-12" [disabled]="busy" (click)="changeEmail()">
            {{ 'auth.contract-link.code.change-email' | translate }}
          </button>
          <button class="button link text-button-12" [disabled]="!canResend" (click)="resendCode()">
            @if (resendCooldown > 0) {
              {{ 'auth.contract-link.code.resend-cooldown' | translate: { seconds: resendCooldown } }}
            } @else {
              {{ 'auth.contract-link.code.resend' | translate }}
            }
          </button>
        </div>
      }

      <!-- The browser is leaving for Google. The last press on the Google button is
      unavoidable - only Cognito can create the session - so it is announced
      here, before the customer meets it. -->
      @if (step === 'redirect') {
        <p class="center">{{ 'auth.contract-link.redirect.message' | translate }}</p>
        <p class="center busy body-12">{{ 'auth.contract-link.redirect.busy' | translate }}</p>
      }
    </div>

    @if (step !== 'redirect') {
      <div class="modal-footer">
        <button class="button secondary" [disabled]="busy" (click)="close()">
          {{ 'auth.contract-link.cancel' | translate }}
        </button>
        @if (step === 'email') {
          <button class="button primary"
            [disabled]="!canSubmitEmail"
            (click)="submitEmail()">
            {{ 'auth.contract-link.email.submit' | translate }}
          </button>
        }
        @if (step === 'code') {
          <button class="button primary"
            [disabled]="!canSubmitCode"
            (click)="submitCode()">
            {{ 'auth.contract-link.code.submit' | translate }}
          </button>
        }
      </div>
    }
